/*
 * This function extracts the timestamp from videoUrls using the 6 digits following the assigned tracker "_tx"
 * It returns a default "1:00" if any errors
 */
export const getVideoDuration = (videoUrl: string) => {
  if (!videoUrl) return "1:00"

  // Find the tracker's index
  const TIMESTAMP_TRACKER = "_tx"
  const timestampIndex = videoUrl.lastIndexOf(TIMESTAMP_TRACKER)
  if (timestampIndex < 0) return "1:00"

  // Fetch 6-digit timestamp preceeded by the tracker
  const sliceStartIndex = timestampIndex + TIMESTAMP_TRACKER.length
  const sliceEndIndex = sliceStartIndex + 6
  let videoTimestamp = videoUrl.slice(sliceStartIndex, sliceEndIndex)
  if (videoTimestamp.length !== 6 || videoTimestamp === "000000" || isNaN(videoTimestamp as any)) return "1:00"

  // Remove leading 0s in the first 3 digits
  while (videoTimestamp.length > 3 && videoTimestamp.charAt(0) === "0") {
    videoTimestamp = videoTimestamp.substring(1)
  }

  // Seperate string into array of 2-digit values, searching from the end using lookup
  const videoDuration = videoTimestamp.match(/.{1,2}(?=(.{2})*$)/g)
  return videoDuration ? videoDuration.join(":") : "1:00"
}
